<template>
  <div>
    <!-- schema: {{ schema }} addBtn:{{ addBtn }} addBtnTitle:{{ addBtnTitle }} -->
    <!-- {{schema.properties}} -->

    <!-- {{ itemModel }} -->
    <!-- model:{{ model }} -->
    <!-- {{VModel}} -->
    <!-- {{parSchema}} -->

    <div class="ml-0">
      <v-menu
        v-if="options.length"
        :key="objKey"
        v-model="menuModel"
        :close-on-content-click="!keepOpen"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <!-- :class="!hideChildTitle ? 'pl-2 mt-n2' : 'ml-n2 mt-n3 mb-n3'" -->

          <v-btn
            text
            small
            :color="color"
            :class="btnClass"
            v-bind="attrs"
            v-if="!addBtn"
            v-on="on"
          >
            <v-icon class="ma-2" v-if="icon">{{ icon }}</v-icon>
            <span v-if="hideChildTitle">{{ title }} </span>

            <span v-else>
              {{ title }}
            </span>
          </v-btn>
          <v-btn
            v-if="addBtn"
            v-bind="attrs"
            v-on="on"
            small
            right
            text
            class="ml-0 mt-2 mb-2 text-right"
          >
            <v-icon class="pr-2" :color="color">mdi-plus-box</v-icon>

            {{ addBtnTitle || schema.add_btn_title }}
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in options"
            :key="index"
            @click="sendValue(item.value, item.text)"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-text-field
          v-if="!noCustomItem"
          class="ml-4 mr-4 mt-n4"
          small
          v-model="model"
          label="custom"
          @click="stayOpen()"
          @keydown.enter="customValue()"
        ></v-text-field>
      </v-menu>
      <v-btn
        v-else
        small
        right
        text
        class="ml-0 mt-2 mb-2 text-right"
        @click="sendValue(schema.newValue)"
      >
        <v-icon class="pr-2" :color="color">mdi-plus-box</v-icon>

        {{ addBtnTitle || schema.add_btn_title }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  props: {
    schema: Object,
    data_key: String,
    VModel: Object,
    itemModel: [Object, Array, String],
    parSchema: Object,
    color: String,
    k: String,
    model_key: String,
    formModel: [Object, Array, String],
    addBtn: Boolean,
    addBtnTitle: String,
    add_option_object: Object,
    hideChildTitle: Boolean,
    addRec: Function,
    btnClass: String,
    icon: String,
    noCustomItem: Boolean,
    btnId: String,
    filter: String,
  },
  data() {
    return {
      options: [],
      title: "",
      item: "",
      keepOpen: false,
      model: "",
      menuModel: 0,
      objKey: 0,
    };
  },
  methods: {
    stayOpen() {
      this.keepOpen = true;
    },
    customValue() {
      this.menuModel = 0;
      this.sendValue(this.model, this.model);
    },
    updateObject(itemValue, itemText) {
      var model = this.VModel[this.model_key][this.k];
      var parModel = this.VModel[this.model_key];
      model[this.data_key] = itemValue;
      var newObjName = itemValue;
      var keys = Object.keys(parModel);
      if (keys.indexOf(itemValue) != -1) {
        var cntExist = 0;
        keys.forEach(function(k) {
          if (
            k.indexOf(itemValue) != -1 &&
            Object.keys(parModel[itemValue]).length
          ) {
            if (!cntExist) {
              cntExist = 1;
            }
            cntExist += 1;
            newObjName = itemValue + "_" + cntExist;
          }
        });
      }
      this.title = fun.capitalize(newObjName);
      // var par = fun.getParentByProperty(this, "componentKey");
      var index = -1;
      Object.keys(this.parSchema).forEach((k, i) => {
        if (k == this.k) {
          index = i;
        }
      });
      var newSchema = fun.addKeyToObject(
        this.parSchema,
        newObjName,
        this.parSchema[this.k],
        index
      );
      newSchema[newObjName].title = this.title;
      parModel[newObjName] = model;

      delete newSchema[this.k];
      delete parModel[this.k];
      var parKeys = Object.keys(this.parSchema);
      var newKeys = Object.keys(newSchema);
      parKeys.forEach((k) => {
        delete this.parSchema[k];
      });
      newKeys.forEach((k) => {
        this.parSchema[k] = newSchema[k];
      });
    },
    updateModel(itemValue, itemText) {
      var cntExist;
      var newObjName = itemValue;
      var that = this;
      if (!this.formModel[this.model_key]) {
        this.formModel[this.model_key] = [];
      }
      this.formModel[this.model_key].forEach((k) => {
        if (k[that.data_key] && k[that.data_key].indexOf(itemValue) != -1) {
          if (!cntExist) {
            cntExist = 1;
          }
          cntExist += 1;
          newObjName = itemValue + "_" + cntExist;
        }
      });
      if (!this.addBtn) {
        this.itemModel[this.data_key] = newObjName;
        this.title = fun.capitalize(newObjName);
      } else {
        this.addRec(newObjName);
        this.objKey = !this.objKey;
        // var newRec = {};
        // newRec[that.data_key] = newObjName;
        // this.itemModel.push(newRec);
      }
    },
    sendValue(itemValue, itemText) {
      this.title = itemText;
      if (this.data_key) {
        if (this.formModel) {
          this.updateModel(itemValue, itemText);
        } else {
          this.updateObject(itemValue, itemText);
        }
      } else {
        if (this.addRec) {
          this.addRec(itemValue);
          this.objKey = !this.objKey;
        }
      }
      this.$root.$emit("labelBtnChanged", {
        obj: this,
        itemValue: itemValue,
        itemText: itemText,
      });
      this.keepOpen = false;
    },
  },
  mounted() {
    // console.log(this.model);
    var that = this;
    if (!this.itemModel) {
      that.title = that.schema["title"];
    } else {
      that.title = fun.capitalize(this.itemModel[this.data_key]);
    }

    var data_key = this.schema.data_key || this.data_key;
    var capitalize = false;
    var properties =
      this.schema.properties || this.schema.table_properties.schema.properties;

    if (properties[data_key] && properties[data_key]["v-bind"]) {
      capitalize = properties[data_key]["v-bind"].capitalizeText;
    }

    if (
      properties[data_key] &&
      properties[data_key]["v-bind"] &&
      properties[data_key]["v-bind"].items
    ) {
      var items = properties[data_key]["v-bind"].items;
      // if (capitalize) {
      //   that.options = items;
      // } else {
      items.forEach(function(i) {
        that.options.push({
          text: i.itemText || fun.capitalize(i),
          value: i.itemValue || i,
        });
      });
      // }
      // items.forEach(function(i) {
      //   if (typeof i == "string") {
      //     that.options.push({
      //       title: i,
      //       value: i,
      //     });
      //   } else {

      //   }
      // });
    }
    // if (this.$props.schema.add_options) {
    //   this.options = this.$props.schema.add_options;
    // }
    if (this.$props.schema.add_option_object) {
      // console.log(this);
      var add_options = this.$props.schema.add_option_object;
      if (add_options.objName) {
        const url =
          this.serverURL +
          "/get_records_qry_string?object_name=" +
          add_options.objName;
        axios
          .get(url, {
            withCredentials: true,
          })
          .then((res) => res.data)
          .then((res) => {
            // console.log(res);
            var records = res.results[0];
            records.forEach(function(r) {
              if (that.filter && !eval(that.filter)) {
                return;
              }
              that.options.push({
                text:
                  capitalize || add_options.capitalizeText
                    ? fun.capitalize(r[add_options.itemText])
                    : r[add_options.itemText],
                value: r[add_options.itemValue],
              });
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        if (add_options.items) {
          that.options = add_options.items;
        }
      }
    }
  },
};
</script>
<style scoped>
.v-menu__content {
  background-color: white !important;
}
.full-btn {
  /* font-size: medium; */
  text-transform: uppercase;
}
</style>
